import React from 'react';
import PropTypes from 'prop-types';

const RoundedDisplay = ({ children, roundedTo = 2, units = null }) => {
  return (
    <>
      {Number(children).toFixed(roundedTo)}
      {units && ` ${units}`}
    </>
  );
};

RoundedDisplay.propTypes = {
  children: PropTypes.number.isRequired,
  roundedTo: PropTypes.number,
  units: PropTypes.string
};

export default RoundedDisplay;
